import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    boxSizing: "border-box",
  },

  shotVersionPageModals: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },

  floatingDiv: {
    position: "fixed",
    right: "0px",
    width: "550px",
    borderLeft: "2px solid #606479",
    backgroundColor: theme.palette.primary.main,
    overflowX: "hidden",
    overflowY: "scroll",
    zIndex: "100",
  },
}));

export default useStyles;
